import { useInView } from "react-intersection-observer";

/**
 * 
 * @param {children} Function, (inView:boolean)=> React.JSX.Element. InView is for the 
 * @returns 
 */
export default function ({ children }) {
  const { ref: viewRef, inView } = useInView({
    threshold: 0.2, // Trigger when 50% of the element is visible
  });

  return (
    <div ref={viewRef} className="h-full snap-center">
      {children({ inView })}
    </div>)
}